import { Component, OnInit, HostListener, Inject } from '@angular/core';
import {
  AbstractControl,
  AsyncValidatorFn,
  UntypedFormBuilder,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { map } from 'rxjs/operators';

import { ControlPermission } from '@pages/modules-permission/interfaces/controlPermission';
import { SwalService } from '@shared/utils/swal.service';
import { UserService } from '@pages/user/services/user.service';
import { ControlesService } from '@pages/modules-permission/services/controles.service';
import { RolService } from '@pages/rol/services/rol.service';
import { Observable, of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-control-form',
  templateUrl: './control-form.component.html',
  styleUrls: ['./control-form.component.css'],
})
export class ControlFormComponent implements OnInit {
  private _user: string = this._userServices.userCurrent;
  public loading: boolean = false;
  public breakpoint: number;
  usser: any = JSON.parse(sessionStorage.getItem('Usser'));
  jsonModules: any[] = [];
  roles: any[] = [];
  habilitado: any[] = [];
  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<ControlFormComponent>,
    private _swalService: SwalService,
    private _controlService: ControlesService,
    private _userServices: UserService,
    private _rolServices: RolService,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public model: ControlPermission
  ) {
    _dialogRef.disableClose = true;
    if (this.model !== null) {
      const setModel = {
        controlName: model.controlName,
        description: model.description,
        enable: model.enable,
        userCreator: model.userCreator,
        permissionControlId: model.permissionControlId,
        visible: model.visible,
        formName: model.formName,
        formId: model.formId,
        rolId: model.rolId,
        controlId: model.controlId,
      };
      this.form.setValue(setModel);
    }
  }

  form = this._fb.group({
    controlName: [''],
    rolId: ['', Validators.required],
    enable: [''],
    userCreator: [this.usser],
    visible: [''],
    formId: [0],
    controlId: ['', Validators.required],
    formName: [''],
    permissionControlId: [+this.route.snapshot.paramMap.get('id')],
    description: [''],
  });

  ngOnInit() {
    this.breakpoint = window.innerWidth <= 400 ? 1 : 2;
    this.jsonModules = JSON.parse(sessionStorage.getItem('Forms'));
    this.usser = JSON.parse(sessionStorage.getItem('Usser'));
    this.loadRols();
  }

  loadRols() {
    this._rolServices.read().subscribe((res) => {
      this.roles = res.data;
    });
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 400 ? 1 : 2;
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this._dialogRef.close();
  }

  close() {
    this._dialogRef.close();
  }

  create(model: ControlPermission) {
    if (this.form.valid) {
      this.loading = true;
      model.enable = true;
      model.visible = true;
      this._controlService.create(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else this._swalService.error('No Agregado');
      });
    }
  }

  update(model: ControlPermission) {
    if (this.form.valid) {
      this.loading = true;
      this._controlService.update(model).subscribe((res) => {
        this.loading = false;
        console.log(res);
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else this._swalService.error('No Editado');
      });
    }
  }

  //#region Get Fb
  formValue(value: string) {
    return this.form.get(value);
  }
  //#endregion

  //#region AsyncValidation
  singleClave(): AsyncValidatorFn {
    return (
      control: AbstractControl
    ): Promise<ValidationErrors> | Observable<any> => {
      if (this.model) return of(true);
      else {
        return this._controlService.readOne(control.value).pipe(
          map((res) => {
            if (res.exito === 1) return { singleClave: true };
            return null;
          })
        );
      }
    };
  }
}
